import { useMemo } from 'react';

export interface FilterRule {
  id: number;
  field: string;
  value: string;
}

export interface QueryBuilderResult {
  params: Record<string, string | string[]>;
  queryString: string;
}

export function useQueryBuilder(
  filters: FilterRule[] = []
): QueryBuilderResult {
  const params = useMemo(() => {
    const paramObj: Record<string, string | string[]> = {};

    filters.forEach(({ field, value }) => {
      // 1. Skip empty values
      if (value === '' || value === null || value === undefined) return;

      // 2. Group duplicates into an array, or assign the string directly
      if (paramObj[field]) {
        paramObj[field] = Array.isArray(paramObj[field])
          ? [...(paramObj[field] as string[]), value] // already an array, append
          : [paramObj[field] as string, value]; // turn string into array
      } else {
        paramObj[field] = value;
      }
    });

    return paramObj;
  }, [filters]);

  const queryString = useMemo(() => {
    return new URLSearchParams(params as Record<string, string>).toString();
  }, [params]);

  return { params, queryString };
}
